import script from "./Root.vue?vue&type=script&setup=true&lang=js"
export * from "./Root.vue?vue&type=script&setup=true&lang=js"

import "./Root.vue?vue&type=style&index=0&id=6465cd3c&lang=scss"

const __exports__ = script;

export default __exports__